import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=260d1a9b&scoped=true&external"
import script from "./Moorage.vue?vue&type=script&lang=js"
export * from "./Moorage.vue?vue&type=script&lang=js"
import style0 from "./Moorage.vue?vue&type=style&index=0&id=260d1a9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260d1a9b",
  null
  
)

export default component.exports